export const DASHBOARD_PAGE_TEXTS = {
    CAPTION: 'friend-referral-program',
    TITLE: 'dashboard-page__title',
    SUBTITLE: 'dashboard-page__subtitle',
    GAME_NAME: 'gameName'
};

export const DEFAULT_STAT_VALUE = 0;
